import { mat4, vec3 } from 'gl-matrix';
import { Grid } from '~/engine/data/common/Grid';
import { DoseInputError } from './doseFactor';

// The image's orientation and extent, sampled at the given spacing (mm).
export function doseGridOverImage(
    imageGrid: Grid,
    spacingMm: readonly [number, number, number]
): Grid {
    if (spacingMm.some((s) => !Number.isFinite(s) || s <= 0)) {
        throw new DoseInputError(
            'Dose grid spacing must be finite and greater than 0 mm.',
            'dose.error.grid'
        );
    }
    if (imageGrid.isEmpty) {
        throw new DoseInputError(
            'The target image has no voxels to place a dose grid on.',
            'dose.error.grid'
        );
    }
    const size = vec3.fromValues(
        Math.max(1, Math.ceil(imageGrid.sizeXMM / spacingMm[0])),
        Math.max(1, Math.ceil(imageGrid.sizeYMM / spacingMm[1])),
        Math.max(1, Math.ceil(imageGrid.sizeZMM / spacingMm[2]))
    );
    const voxelToWorld = mat4.multiply(
        mat4.create(),
        imageGrid.voxelToWorld,
        mat4.fromScaling(
            mat4.create(),
            vec3.fromValues(
                spacingMm[0] / imageGrid.resX,
                spacingMm[1] / imageGrid.resY,
                spacingMm[2] / imageGrid.resZ
            )
        )
    );
    return Grid.fromVoxelToWorld(size, voxelToWorld);
}
